// header.interceptor.ts
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  DefaultParams,
  HeaderAuthInterface,
} from '../interfaces/auth.interface';
import {
  _DEFAULT_PARMAS_STATE,
  _HEADER_AUTH_STATE,
} from '../../data/store/session/sesion.selectors';

export const setHeaderInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const store = inject(Store);

  let sesion: HeaderAuthInterface = {} as HeaderAuthInterface;
  let defaulParams: DefaultParams = {} as DefaultParams;

  store
    .select(_HEADER_AUTH_STATE)
    .subscribe(response => (sesion = response))
    .unsubscribe();
  store
    .select(_DEFAULT_PARMAS_STATE)
    .subscribe(response => (defaulParams = response))
    .unsubscribe();

  const pathsExcluded = [
    '/validar/',
    '/login/',
    '/re-enviar-codigo-validacion/',
    'https://api.ipify.org/?format=json',
    'https://www.googleapis.com/geolocation/v1/geolocate',
  ];

  const shouldAddToken =
    !pathsExcluded.some(path => req.url.includes(path)) && sesion?.token;

  if (shouldAddToken) {
    req = req.clone({
      url: req.url.replace('/email/', `/${defaulParams.email}/`),
    });
    req = req.clone({
      url: req.url.replace('/id_solicitud/', `/${defaulParams.id}/`),
    });

    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${sesion.token}`,
      },
      setParams: {
        wf: `${sesion.id_wf ?? 1}`,
      },
    });
  }

  return next(req);
};
